module.exports = __webpack_public_path__ + "img/arrow_yellow.dd003cef.svg";